var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"about"}},[_c('h3',{staticClass:"headline"},[_vm._v("About")]),_c('p',[_vm._v(_vm._s(_vm.About)+" "),_c('span',{on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.Toggle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }